import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { map, catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as productGroupsActions from '../actions/product-groups.actions';
import * as notifyActions from 'app/store/general/actions/notify.actions';
import { MwProductGroupsApiService } from 'app/services/product-groups-api.service';

@Injectable()
export class ProductGroupsEffects {
  loadProductGroups$ = createEffect(() =>
    this.actions$.pipe(
      ofType(productGroupsActions.loadProductGroups),
      switchMap(({ loadOptions }) =>
        this.productGroupsApiService.getProductGroups(loadOptions).pipe(
          map((response) =>
            productGroupsActions.loadProductGroupsSuccess({ response })
          ),
          catchError((error) =>
            of(productGroupsActions.loadProductGroupsFailed({ error }))
          )
        )
      )
    )
  );

  createProductGroup$ = createEffect(() =>
    this.actions$.pipe(
      ofType(productGroupsActions.createProductGroup),
      switchMap(({ productGroup }) =>
        this.productGroupsApiService.createProductGroup(productGroup).pipe(
          switchMap(() => [
            productGroupsActions.createProductGroupSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.add_product_group_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(productGroupsActions.createProductGroupFailed({ error }))
          )
        )
      )
    )
  );

  updateProductGroup$ = createEffect(() =>
    this.actions$.pipe(
      ofType(productGroupsActions.updateProductGroup),
      switchMap(({ productGroup }) =>
        this.productGroupsApiService.updateProductGroup(productGroup).pipe(
          switchMap((response) => [
            productGroupsActions.updateProductGroupSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.edit_product_group_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(productGroupsActions.updateProductGroupFailed({ error }))
          )
        )
      )
    )
  );

  deleteProductGroup$ = createEffect(() =>
    this.actions$.pipe(
      ofType(productGroupsActions.deleteProductGroup),
      switchMap(({ productGroup }) =>
        this.productGroupsApiService.deleteProductGroup(productGroup).pipe(
          switchMap(() => [
            productGroupsActions.deleteProductGroupSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.delete_product_group_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(productGroupsActions.deleteProductGroupFailed({ error }))
          )
        )
      )
    )
  );

  deleteProductGroupsList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(productGroupsActions.deleteProductGroupsList),
      switchMap(({ productGroups }) =>
        this.productGroupsApiService
          .deleteProductGroupsList(productGroups)
          .pipe(
            switchMap(() => [
              productGroupsActions.deleteProductGroupsListSuccess(),
              notifyActions.notifySuccess({
                notification: {
                  phrase: 'OPERATION.delete_product_groups_successful',
                },
              }),
            ]),
            catchError((error) =>
              of(productGroupsActions.deleteProductGroupsListFailed({ error }))
            )
          )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private productGroupsApiService: MwProductGroupsApiService
  ) {}
}
